module.exports = __webpack_public_path__ + "static/media/collage2_2_1366.3265d98c.png";